exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slidecontainer {\r\n    width: 100%;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-pack: justify;\r\n        justify-content: space-between;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n  }\r\n.min-max-text {\r\n  font-weight: bold;\r\n}\r\n  \r\n  .slider {\r\n    -webkit-appearance: none;\r\n    width: 90%;\r\n    height: 12px;\r\n    background: #d3d3d3;\r\n    outline: none;\r\n    opacity: 0.7;\r\n    border-radius: 10px;\r\n    transition: opacity .2s;\r\n  }\r\n  \r\n  .slider:hover {\r\n    opacity: 1;\r\n  }\r\n  \r\n  .slider::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    width: 25px;\r\n    height: 25px;\r\n    background: #4CAF50;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n  }\r\n  \r\n  .slider::-moz-range-thumb {\r\n    width: 25px;\r\n    height: 25px;\r\n    background: #4CAF50;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/app/shared/range-slider/range-slider.component.css
// module id = ../../../../../src/app/shared/range-slider/range-slider.component.css
// module chunks = main